import { get } from './get';
/**
 * Replaces placeholders with real content
 * Requires get() - https://vanillajstoolkit.com/helpers/get/
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {String} template The template string
 * @param {String} local    A local placeholder to use, if any
 */
export var placeholders = function (template, data, translations) {
    // Check if the template is a string or a function
    // template = typeof (template) === 'function' ? template() : template;
    if (['string', 'number'].indexOf(typeof template) === -1) {
        return template; // throw 'PlaceholdersJS: please provide a valid template';
    }
    // If no data, return template as-is
    if (!data)
        return template;
    // Replace our curly braces with data
    template = template.replace(/\{\{([^}]+)\}\}/g, function (match) {
        // Remove the wrapping curly braces
        match = match.slice(2, -2);
        // Get the value
        var val = get(data, match.trim());
        // Replace
        if (val === undefined) {
            return "{{" + match + "}}";
        }
        return val;
    });
    // If translations are provided we should also replace those.
    // Syntax for translations: [[TranslationKey]]
    if (!!translations) {
        template = template.replace(/\[\[[a-z]+\]\]/gi, function (match) {
            // Remove the wrapping square braces
            match = match.slice(2, -2);
            var translation = translations[match];
            if (translation === undefined) {
                return "[[" + match + "]]";
            }
            return translation;
        });
    }
    return template;
};
